import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {AngularFireAuthGuard, redirectUnauthorizedTo} from '@angular/fire/auth-guard';
const redirectUnauthorizedToWelcome = () => redirectUnauthorizedTo(['welcome']);

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToWelcome}
  },
  {
    path: 'return',
    loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule)
  },
  {
    path: 'n/:query',
    loadChildren: () => import('./pages/new/new.module').then( m => m.NewPageModule)
  },
  {
    path: 'n',
    redirectTo: 'tabs',
    pathMatch: 'full'
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then( m => m.WelcomePageModule)
  },
  {
    path: 'venue-details/:venueId',
    loadChildren: () => import('./pages/venue-details/venue-details.module').then( m => m.VenueDetailsPageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./modals/privacy-policy/privacy-policy.module').then( m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'shop-details',
    loadChildren: () => import('./modals/shop-details/shop-details.module').then( m => m.ShopDetailsPageModule)
  },
  {
    path: 'qr-scanner',
    loadChildren: () => import('./modals/qr-scanner/qr-scanner.module').then( m => m.QrScannerPageModule),
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToWelcome}
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/auth/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'login-to-pay',
    loadChildren: () => import('./pages/auth/login-to-pay/login-to-pay.module').then( m => m.LoginToPayPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/auth/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'map-view',
    loadChildren: () => import('./pages/map-view/map-view.module').then( m => m.MapViewPageModule),
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToWelcome}
  },
  {
    path: 'loading-full-screen',
    loadChildren: () => import('./modals/loading-full-screen/loading-full-screen.module').then( m => m.LoadingFullScreenPageModule)
  },
  {
    path: 'edit-profile',
    loadChildren: () => import('./pages/edit-profile/edit-profile.module').then( m => m.EditProfilePageModule),
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToWelcome}
  },
  {
    path: 'image-cropper',
    loadChildren: () => import('./modals/image-cropper/image-cropper.module').then( m => m.ImageCropperPageModule)
  },
  {
    path: 'history',
    loadChildren: () => import('./pages/history/history.module').then( m => m.HistoryPageModule),
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToWelcome}
  },
  {
    path: 'messages',
    loadChildren: () => import('./pages/messages/messages.module').then( m => m.MessagesPageModule),
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToWelcome}
  },
  {
    path: 'change-password',
    loadChildren: () => import('./pages/change-password/change-password.module').then( m => m.ChangePasswordPageModule),
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToWelcome}
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'verify-email',
    loadChildren: () => import('./modals/verify-email/verify-email.module').then( m => m.VerifyEmailPageModule)
  },
  {
    path: 'change-email',
    loadChildren: () => import('./modals/change-email/change-email.module').then( m => m.ChangeEmailPageModule)
  },
  {
    path: 'fill-information',
    loadChildren: () => import('./pages/fill-information/fill-information.module').then( m => m.FillInformationPageModule),
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToWelcome}
  },
  {
    path: 'request-ride',
    loadChildren: () => import('./modals/request-ride/request-ride.module').then( m => m.RequestRidePageModule)
  },
  {
    path: 'upgrade-account',
    loadChildren: () => import('./modals/upgrade-account/upgrade-account.module').then( m => m.UpgradeAccountPageModule)
  },
  {
    path: 'review-ride',
    loadChildren: () => import('./modals/review-ride/review-ride.module').then( m => m.ReviewRidePageModule)
  },
  {
    path: 'chat/:id/:type',
    loadChildren: () => import('./pages/chat/chat.module').then( m => m.ChatPageModule),
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToWelcome}
  },
  {
    path: 'chat-history',
    loadChildren: () => import('./pages/chat-history/chat-history.module').then( m => m.ChatHistoryPageModule),
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToWelcome}
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
